export default {
    CURRENT_ENROLMENT_PROVIDER_ID: 'currentEnrolmentProviderId',
    CURRENT_ENROLMENT_COURSE_ID: 'currentEnrolmentCourseId',
    CURRENT_ENROLMENT_REGION_ID: 'currentEnrolmentRegionId',
    CURRENT_ENROLMENT_DELIVERY_TYPE_ID: 'currentEnrolmentDeliveryTypeId',
};
